import React, { useEffect } from 'react';

import { ClickableIcon, ContainerHeader, Toolbar } from '~components';
import { faMagnifyingGlass, faMoneyBill } from '~components/icon';

import { setTitle } from '~main/actions/login';

const DirectDebitsContainer: React.FC = () => {
  useEffect(() => {
    setTitle('Direct Debits - GoCardless');
  }, []);

  return (
    <div className="p-2">
      <ContainerHeader icon={faMoneyBill} iconSize="1x" className="info" dataCy="direct-debits-header">
        Direct Debits — GoCardless
      </ContainerHeader>
      <Toolbar
        id="direct-debits"
        rightCluster={<ClickableIcon id="direct-debits-search-button" icon={faMagnifyingGlass} toolTip="Search" />}
      />
      <div className="p-3 text-muted" data-cy="direct-debits-placeholder">
        Direct Debits dashboard — placeholder
      </div>
    </div>
  );
};

export default DirectDebitsContainer;
